import { render, staticRenderFns } from "./FormulaNutrition.vue?vue&type=template&id=a5462686"
import script from "./FormulaNutrition.vue?vue&type=script&lang=js"
export * from "./FormulaNutrition.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports